import {
  geRouteAiLogs,
  getRouteAiEvals,
  getRouteAiEvalsClaims,
  getRouteAuthLogs,
  getRouteClaudeRuns,
  getRouteCriteriaLogs,
  getRouteDashboard,
  getRouteDeficiencies,
  getRouteFeatureFlags,
  getRouteImportUsers,
  getRouteGenerationMode,
  getRouteInviteUser,
  getRouteOrganizations,
  getRoutePrompts,
  getRouteTemplates
} from "@/zapi-admin/shared/const/router";

export type TNavLink = {
  label: string;
  to: string;
  testId: string;
  activePath?: string;
  systemAdminOnly?: boolean;
};

export type TNavGroup = {
  label: string;
  testId: string;
  items: TNavLink[];
};

export type TNavEntry = TNavLink | TNavGroup;

export function isNavGroup(entry: TNavEntry): entry is TNavGroup {
  return "items" in entry;
}

export function isPathActive(pathname: string, link: TNavLink) {
  const path = link.activePath ?? link.to;

  return pathname === path || pathname.startsWith(`${path}/`);
}

export const navEntries: TNavEntry[] = [
  { label: "Dashboard", to: getRouteDashboard(), testId: "nav-dashboard" },
  {
    label: "Organizations",
    testId: "nav-group-organizations",
    items: [
      { label: "All Organizations", to: getRouteOrganizations(), testId: "nav-organizations" },
      { label: "Feature Flags", to: getRouteFeatureFlags(), testId: "nav-feature-flags" },
      { label: "Templates", to: getRouteTemplates(), testId: "nav-templates" }
    ]
  },
  {
    label: "Users",
    testId: "nav-group-users",
    items: [
      { label: "Invite User", to: getRouteInviteUser(), testId: "nav-invite-user" },
      { label: "Import Users", to: getRouteImportUsers(), testId: "nav-import-users" },
      {
        label: "Generation Mode",
        to: getRouteGenerationMode(),
        testId: "nav-generation-mode",
        systemAdminOnly: true
      }
    ]
  },
  {
    label: "AI",
    testId: "nav-group-ai",
    items: [
      { label: "Prompts", to: getRoutePrompts(), testId: "nav-prompts" },
      { label: "AI Evals", to: getRouteAiEvalsClaims(), activePath: getRouteAiEvals(), testId: "nav-ai-evals" },
      { label: "Deficiencies", to: getRouteDeficiencies(), testId: "nav-deficiencies", systemAdminOnly: true }
    ]
  },
  {
    label: "Logs",
    testId: "nav-group-logs",
    items: [
      { label: "Criteria Logs", to: getRouteCriteriaLogs(), testId: "nav-criteria-logs" },
      { label: "AI Logs", to: geRouteAiLogs(), testId: "nav-ai-logs" },
      { label: "Auth Logs", to: getRouteAuthLogs(), testId: "nav-auth-logs" },
      { label: "Claude Runs", to: getRouteClaudeRuns(), testId: "nav-claude-runs" }
    ]
  }
];
